import React from 'react';

// TOGΞ himself, faint in the background of a panel, with his eyes, mouth and body shapes lighting up every few seconds
// (the styles are in index.css). Rendered even before the avatar has loaded, so his lights start at the same moment
// as the rest of the page's animations and stay in time with them.

// /toge-lights.webp is made from this one avatar (its ID in Discord's link), so a different avatar just goes without
// lights rather than having them in the wrong places, until a new image is made for it
const LIGHTS_AVATAR = '6430752f18d22f49145f5cb228221937';

export default function TogeBot({ avatar, className = '' }) {
  return (
    // The avatar's link asks for 256px (for the small ones), far too blurry at the big size
    <div className={`tg-bot ${className}`} aria-hidden="true"
      style={{ '--tg-bot': avatar ? `url("${avatar.replace(/size=\d+/, 'size=1024')}")` : 'none' }}>
      <div className="tg-bot-img" />
      <div className="tg-bot-lit" style={avatar?.includes(LIGHTS_AVATAR) ? { backgroundImage: "url('/toge-lights.webp')" } : undefined} />
    </div>
  );
}
